import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
	list: [],
	error: "",
	loading: false,
};

export const loadDashboardData = createAsyncThunk(
	"dashboard/loadDashboardData",
	async ({ startdate, enddate }) => {
		try {
			const { data } = await axios.get(
				`dashboard?startdate=${startdate}&enddate=${enddate}`
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getAllExpiryDate = createAsyncThunk(
	"dashboard/getAllExpiryDate",
	// async ({ startdate, enddate }) => {
		async () => {
		try {
	console.log("expiryDate called")

			const { data } = await axios.get(
				`dashboard/expiryDate?query=all`
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

const dashboardSlice = createSlice({
	name: "dashboard",
	initialState,
	extraReducers: (builder) => {
		// 1) ====== builders for loadDashboardData ======

		builder.addCase(loadDashboardData.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadDashboardData.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadDashboardData.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 2) ====== builders for getAllExpiryDate ======

		builder.addCase(getAllExpiryDate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllExpiryDate.fulfilled, (state, action) => {
			state.loading = false;
			state.sensitiveData = action.payload;
		});

		builder.addCase(getAllExpiryDate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});
	},
});

export default dashboardSlice.reducer;
